<template>
  <div id="parkingGeoMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>地磁管理</el-breadcrumb-item>
          <el-breadcrumb-item>地磁列表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-row>
          <el-col :span="22">
            <el-form-item label="客户名称::">
              <el-select v-model="selCustID"
                         filterable
                         clearable
                         placeholder="请选择客户"
                         @change="setPark($event,0)">
                <el-option v-for="item in choiceCusts"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场库名称::">
              <el-select v-model="selfParkID"
                         filterable
                         clearable
                         placeholder="请选择场库">
                <el-option v-for="item in choiceParks"
                           :key="item.fParkID"
                           :label="item.fParkName"
                           :value="item.fParkID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字::">
              <el-input placeholder="请输入车位编号/地磁设备ID"
                        v-model="searchKeyWord">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         icon="el-icon-search"
                         size="small"
                         @click="bindQuery">查询</el-button>
              <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
              <el-button type="success"
                     size="small"
                     icon="el-icon-download"
                     :loading="download_loading"
                     @click="createTemplate">创建模板</el-button>
              <el-button type="warning"
                     icon="el-icon-upload"
                     size="small"
                     v-if="is_import"
                     @click="importData">导入</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  class="searchRowAdd">
            <el-button type="primary"
                       size="small"
                       @click="addSyncChannel">新增地磁</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="chnlList"
                border
                v-loading="loading"
                highlight-current-row
                style="width: 100%"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column type="index"
                          width="50"
                          :index="indexMethod"
                          label="序号">
        </el-table-column>
        <el-table-column prop="fOpLastTime"
                          width="150"
                          label="最后同步时间">
        </el-table-column>
        <el-table-column prop="fCustNo"
                          width="90px"
                          label="客户编号">
        </el-table-column>
        <el-table-column prop="fCustName"
                          width="105"
                          label="客户名称">
        </el-table-column>
        <el-table-column prop="fParkNo"
                          width="90px"
                          label="场库编号">
        </el-table-column>
        <el-table-column prop="fParkName"
                          width="115px"
                          label="场库名称">
        </el-table-column>
        <el-table-column prop="fFloorName"
                          width="90px"
                          label="楼层名称">
        </el-table-column>
        <el-table-column prop="fAreaName"
                          width="90px"
                          label="区域名称">
        </el-table-column>
        <el-table-column prop="fPlaceNo"
                          width="90px"
                          label="车位编号">
        </el-table-column>
        <el-table-column prop="fDevProdID"
                          width="90px"
                          label="设备厂商">
        </el-table-column>
        <el-table-column prop="fDeviceID"
                          width="140px"
                          label="地磁设备ID">
        </el-table-column>
        <el-table-column prop="fStatus"
                          width="70px"
                          label="状态">
        </el-table-column>
        <el-table-column prop="fVoltage"
                          width="110px"
                          label="电池电压(mV)">
        </el-table-column>
        <el-table-column prop="fDataType"
                          width="105px"
                          label="消息类型">
        </el-table-column>
        <el-table-column prop="fDevRssi"
                          width="115px"
                          align="right"
                          label="信号强度(dBm)">
        </el-table-column>
        <el-table-column prop="fUploadTimeTemp"
                          width="150"
                          label="车位变化时间">
        </el-table-column>
        <el-table-column prop="fRemark"
                          label="备注">
        </el-table-column>
        <el-table-column fixed="right"
                          label="操作"
                          align="center"
                          width="230">
          <template slot-scope="scope">
            <el-button @click="viewChannel(scope.row)"
                        type="success"
                        size="mini">查看</el-button>
            <el-button size="mini"
                        type="warning"
                        v-if="is_edit"
                        @click="editChannel(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini"
                        type="danger"
                        v-if="is_del"
                        @click="deleteChnlClient(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="myChnlEditOrDetail">
      <el-dialog :title="detailTitle"
                 v-dialogDrag
                 :visible.sync="chnlEditOrDetailVisible"
                 class="channelDialog"
                 top="20vh"
                 left="0vh"
                 width="50%">
        <el-form :model="curRowInfo"
                       :rules="groupRules"
                       ref="parkLockForm"
                       label-width="115px">
          <el-row style="padding-top:10px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="客户名称::" prop="fCustID">
                <el-select v-model="curRowInfo.fCustID"
                        filterable
                        placeholder="请选择客户"
                        :disabled="!curRowInfo.isEdit || !curRowInfo.edit"
                        class="myChnlInput"
                        style="width: 100%"
                        @change="setPark($event,1)">
                  <el-option v-for="item in choiceCusts"
                            :key="item.fCustID"
                            :label="item.unionName"
                            :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="场库名称::" prop="fParkID">
                <el-select v-model="curRowInfo.fParkID"
                        filterable
                        placeholder="请选择场库"
                        :disabled="!curRowInfo.isEdit || !curRowInfo.edit"
                        class="myChnlInput"
                        style="width: 100%">
                  <el-option v-for="item in parks"
                            :key="item.fParkID"
                            :label="item.fParkName"
                            :value="item.fParkID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="楼层名称::"
                            prop="fFloorName">
                <el-input v-model="curRowInfo.fFloorName"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="区域名称::"
                            prop="fAreaName">
                <el-input v-model="curRowInfo.fAreaName"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车位编号::"
                            prop="fPlaceNo">
                <el-input v-model="curRowInfo.fPlaceNo"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="设备ID::"
                            prop="fDeviceID">
                <el-input v-model="curRowInfo.fDeviceID"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="16">
              <el-form-item label="三方调用地址::">
                <el-input v-model="curRowInfo.fThiPubUrl"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="三方token::">
                <el-input v-model="curRowInfo.fThiToken"
                          style="width:100%"
                          placeholder="http头部token，没有为空"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="16">
              <el-form-item label="备注::">
                <el-input v-model="curRowInfo.fRemark"
                          type="textarea"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitForm('parkLockForm')"
                     v-if="curRowInfo.isEdit"
                     :loading="save_loading">{{save_msg}}</el-button>
          <el-button @click="chnlEditOrDetailVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="myChnlEditOrDetail">
    <el-dialog title="导入地磁数据"
               :visible.sync="importDataVisible"
               width="65%"
               top="7vh"
               v-dialogDrag>
      <el-form label-width="120px">
        <!--<el-form-item label="选择客户::">
          <el-select v-model="importModel.fCustID"
                     style="width:250px"
                     filterable
                     @change="changeImportCust"
                     :disabled="importModel.btnOkLoading||importModel.btnLoading"
                     placeholder="请选择::">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="导入excel文件::"
                      style="height:65px;padding-top:20px">
          <el-upload class="upload-demo"
                     action="#"
                     :show-file-list='false'
                     :on-success="uploadSuccess"
                     :http-request="uploadExcel">
            <el-button size="small"
                       type="primary"
                       :disabled="importModel.btnOkLoading"
                       :loading="importModel.btnLoading">{{importModel.btnMsg}}</el-button>
            <div slot="tip"
                 class="el-upload__tip">只能上传Excel文件</div>
          </el-upload>
        </el-form-item>
        <el-row>
          <el-col :span="24">
            <el-table :data="importModel.data"
                      :row-class-name="tableErrorRowClassName"
                      border
                      v-loading="importModel.loading"
                      highlight-current-row
                      style="width: 100%"
                      height="400">
              <el-table-column prop="num"
                               width="50"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fCustID"
                               v-if="false"
                               label="客户ID">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fParkID"
                               v-if="false"
                               label="场库ID">
              </el-table-column>
              <el-table-column prop="fParkNo"
                               width="135"
                               label="场库编号">
              </el-table-column>
              <el-table-column prop="fParkName"
                               width="135"
                               label="场库名称">
              </el-table-column>
              <el-table-column prop="fFloorName"
                               label="楼层名称">
              </el-table-column>
              <el-table-column prop="fAreaName"
                               label="区域地址">
              </el-table-column>
              <el-table-column prop="fPlaceNo"
                               label="车位编号">
              </el-table-column>
              <el-table-column prop="fDeviceID"
                               label="设备ID">
              </el-table-column>
              <el-table-column prop="fThiPubUrl"
                               label="三方调用地址">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
              <el-table-column label="错误信息"
                               fixed="right">
                <template slot-scope="scope">
                  <el-tooltip placement="left">
                    <div slot="content"
                         v-html="scope.row.fErrorMsg"></div>
                    <span>{{scope.row.fErrorMsg}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :disabled="importModel.btnOkDisabled"
                   @click="importOk"
                   v-if="is_import"
                   :loading="importModel.btnOkLoading">{{importModel.btnOkMsg}}</el-button>
        <el-button @click="importDataVisible = false">取消</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'parkingGeoMain.vue',
  data () {
    return {
      loading: false,
      is_edit: false,
      is_del: false,
      is_export: false,
      is_import: false,
      export_msg: '导出',
      export_loading: false,
      save_msg: '保存',
      save_loading: false,
      selCustID: '',
      choiceCusts: [],
      curRowInfo: {
        fDcDevID: 0,
        edit: false,
        isEdit: false,
        fCustID: '',
        fCustNo: '',
        fCustName: '',
        fParkID: '',
        fParkNo: '',
        fParkName: '',
        fFloorName: '',
        fAreaName: '',
        fPlaceNo: '',
        fDeviceID: '',
        fThiPubUrl: '',
        fThiToken: '',
        fRemark: ''
      },
      groupRules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        fParkID: [
          { required: true, message: '请选择场库', trigger: 'change' }
        ],
        fFloorName: [
          { required: true, message: '请输入楼层名称', trigger: 'change' }
        ],
        fAreaName: [
          { required: true, message: '请输入区域名称', trigger: 'change' }
        ],
        fPlaceNo: [
          { required: true, message: '请输入车位编号', trigger: 'change' }
        ],
        fDeviceID: [
          { required: true, message: '请输入地磁设备ID', trigger: 'change' }
        ]
      },
      chnlEditOrDetailVisible: false,
      detailTitle: '查看通道信息',
      choiceParks: [],
      parks: [],
      selfParkID: '',
      searchKeyWord: '',
      chnlList: [],
      tableHeight: 200,
      form: {

      },
      pageSize: 20,
      pageNo: 1,
      total: 0,
      importDataVisible: false,
      download_loading: false,
      importModel: {
        fCustID: '',
        data: [],
        loading: false,
        btnMsg: '点击上传',
        btnLoading: false,
        btnOkDisabled: true,
        btnOkMsg: '确定导入',
        btnOkLoading: false
      }
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {
    ...mapActions([
      'getParkList', 'getParkingGeoQuery', 'parkGeoDataUpload', 'importParkGeoData', 'parkGeoDataTemplate', 'getChannelParamById', 'getCustByGroup', 'saveParkGeomagnetic', 'deleteParkGeo', 'ascParkLock', 'descParkLock', 'descOrAecParkLock', 'getParkLockStatus', 'synChnlById', 'getCurrentUserPers'
    ]),
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save_loading = true
          this.save_msg = '保存中…'
          this.saveParkGeomagnetic(this.curRowInfo).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.chnlEditOrDetailVisible = false
                this.initData()
                this.$message.success(data.Msg)
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    addSyncChannel () {
      setTimeout(() => {
        if (this.$refs['parkLockForm']) {
          this.$refs['parkLockForm'].clearValidate()
        }
      }, 50)
      this.detailTitle = '新增地磁'
      this.chnlEditOrDetailVisible = true
      this.curRowInfo = {
        fDcDevID: 0,
        edit: true,
        isEdit: true,
        fCustID: '',
        fCustNo: '',
        fCustName: '',
        fParkID: '',
        fParkNo: '',
        fParkName: '',
        fFloorName: '',
        fAreaName: '',
        fPlaceNo: '',
        fDeviceID: '',
        fThiPubUrl: '',
        fThiToken: '',
        fRemark: ''
      }
    },
    uploadSuccess (response, file, fileList) {
      console.log('file upload success')
    },
    uploadExcel (file) {
      // if ((this.importModel.fCustID || '').trim().length <= 0) {
      // this.$message.error('提示：请先选择客户!')
      // return
      // }
      var exts = ['.xls', '.xlsx']
      var fileExt = file.file.name.substring(file.file.name.lastIndexOf('.')).toLowerCase()
      const isJPG = exts.indexOf(fileExt) !== -1
      const isLt500k = file.file.size / 1024 < 500

      if (!isJPG) {
        this.$message.error('提示：上传文件只能是 xls/xlsx 格式!')
        return
      }
      if (!isLt500k) {
        this.$message.error('提示：上传图片大小不能超过 500KB!')
        return
      }
      this.importModel.btnOkDisabled = true
      this.importModel.data = []
      this.importModel.loading = true
      this.importModel.btnLoading = true
      this.importModel.btnMsg = '导入中……'
      let data = new FormData()
      data.append('cradFile', file.file)
      data.append('fCustID', this.importModel.fCustID)
      this.parkGeoDataUpload(data).then(res => {
        // this.importModel.custDisabled = false
        this.importModel.btnLoading = false
        this.importModel.btnMsg = '点击上传'
        this.importModel.loading = false
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            var importData = data.Data || []
            this.importModel.data = importData
            if (importData.filter(r => r.fIsErr === false).length > 0) {
              this.importModel.btnOkDisabled = false
            }
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    importData () {
      if (this.importModel.btnMsg !== '导入中……' && this.importModel.btnOkMsg !== '导入中……') {
        this.importModel.fCustID = ''
        this.importModel.data = []
        this.importModel.btnOkDisabled = true
      }
      this.importDataVisible = true
    },
    importOk () {
      var data = this.importModel.data.filter(r => r.fIsErr === false)
      this.importModel.btnOkLoading = true
      this.importModel.btnOkMsg = '导入中……'
      this.importParkGeoData({ fCustID: this.importModel.fCustID, data: data }).then(res => {
        this.importModel.btnOkLoading = false
        this.importModel.btnOkMsg = '确定导入'
        this.importModel.btnOkDisabled = true
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.$message({
              type: 'success',
              message: data.Msg
            })
            this.initData()
            if (data.Data.length > 0) {
              this.importModel.data = data.Data
            } else {
              this.importDataVisible = false
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    createTemplate () {
      this.download_loading = true
      this.parkGeoDataTemplate().then(res => {
        this.download_loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, '场库地磁管理导入模板.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    exportData () {
      // if ((this.selCustID || '').trim().length <= 0) {
      //   this.$message.error('提示：请先选择客户')
      //   return false
      // }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      let chnlParam = {}
      chnlParam['fParkID'] = this.selfParkID
      chnlParam['fCustID'] = this.selCustID
      chnlParam['searchKeyWord'] = this.searchKeyWord
      chnlParam.pageSize = this.pageSize
      chnlParam.pageNo = this.pageNo
      chnlParam.exportData = 1
      this.getParkingGeoQuery(chnlParam).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_场库地磁数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    bindQuery () {
      this.initData()
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tableErrorRowClassName ({ row, rowIndex }) {
      if (row.fIsErr) {
        return 'error-row'
      }
      return ''
    },
    initData () {
      let chnlParam = {}
      chnlParam['fParkID'] = this.selfParkID
      chnlParam['fCustID'] = this.selCustID
      chnlParam['searchKeyWord'] = this.searchKeyWord
      chnlParam.pageSize = this.pageSize
      chnlParam.pageNo = this.pageNo
      chnlParam.exportData = 0
      this.loading = true
      this.getParkingGeoQuery(chnlParam).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              // let tmpChnl = []
              // Object.assign(tmpChnl, data.Data.rows)
              this.chnlList = data.Data.rows || []
              this.total = data.Data.total
            }
          }
        }
      })
    },
    editChannel (index, row) {
      setTimeout(() => {
        if (this.$refs['parkLockForm']) {
          this.$refs['parkLockForm'].clearValidate()
        }
      }, 50)
      this.detailTitle = '编辑地磁【' + row.fDeviceID + '】'
      this.chnlEditOrDetailVisible = true
      this.getParkList({ fCustID: row.fCustID }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parks = data.Data
            }
          }
        }
      })
      this.curRowInfo = {}
      this.curRowInfo = row
      this.curRowInfo.isEdit = true
      this.curRowInfo.edit = false
      this.setPark(row.fCustID, 0, row.fParkID)
    },
    viewChannel (row) {
      setTimeout(() => {
        if (this.$refs['parkLockForm']) {
          this.$refs['parkLockForm'].clearValidate()
        }
      }, 50)
      this.detailTitle = '查看地磁【' + row.fDeviceID + '】'
      this.chnlEditOrDetailVisible = true
      this.getParkList({ fCustID: row.fCustID }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parks = data.Data
            }
          }
        }
      })
      this.curRowInfo = {}
      this.curRowInfo = row
      this.curRowInfo.isEdit = false
      this.curRowInfo.edit = false
    },
    deleteChnlClient (index, row) {
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteParkGeo({ fDcDevID: row.fDcDevID }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    setPark (val, type, fParkID = '') {
      if (type === 0) {
        this.choiceParks = []
        this.selfParkID = ''
      } else if (type === 1) {
        this.parks = []
        if ((fParkID || '').trim().length <= 0) {
          this.curRowInfo.fParkID = ''
        }
      }
      this.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              if (type === 0) {
                this.choiceParks = data.Data || []
              } else if (type === 1) {
                this.parks = data.Data || []
              }
            }
          }
        }
      })
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 26100 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_export = data.Data.data.is_export
            this.is_import = data.Data.data.is_import
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.getCustByGroup({ fCustTypeID: 0 }).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.fGrpID = this.choiceCusts[0].fGrpID
              this.setPark(this.selCustID, 0)
            }
          }
        }
      }
    })
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
/* #parkingGeoMain .el-input__inner {
  height: 32px;
  line-height: 32px;
  font-size: 13px;
} */
/* .myChnlEditOrDetail .el-textarea__inner {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 13px;
} */
.myChnlEditOrDetail .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
.myChnlEditOrDetail
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
.myChnlEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.myChnlEditOrDetail .el-dialog__title {
  color: white;
}
.myChnlEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.myChnlEditOrDetail .el-dialog__body {
  padding: 5px;
  padding-bottom: 0px;
}
.myChnlEditOrDetail .ledDialog .el-dialog__body {
  padding: 0px;
}
.myChnlEditOrDetail .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #666666;
  cursor: not-allowed;
  /*font-family: 宋体;*/
  font-size: 13px;
}
.myChnlEditOrDetail .myChnlLableClass {
  text-align: right;
  float: left;
  color: #606266;
  line-height: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /*font-family: 宋体;*/
  font-size: 13px;
}
.myChnlEditOrDetail .is-disabled .el-input__inner,
.myChnlEditOrDetail .is-disabled .el-textarea__inner {
  color: #606266;
}
.myChnlEditOrDetail .el-row {
  margin-bottom: 5px;
}
.myChnlEditOrDetail .el-radio {
  line-height: 2px;
}
/* dialog弹出框样式 */
#parkingGeoMain .channelDialog .el-dialog {
  min-width: 910px;
}
#parkingGeoMain .screenDialog .el-dialog {
  min-width: 800px;
}
#parkingGeoMain .voiceDialog .el-dialog {
  min-width: 410px;
}
#parkingGeoMain .warning-row {
  color: chocolate;
}
#parkingGeoMain .error-row {
  color: #fb4545;
}
</style>

<style scoped>
fieldset {
  padding-bottom: 0px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.searchRowAdd {
  text-align: right;
}
.el-upload__tip {
  margin-top: 0px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/view/park/parkingGeoMain.vue